export const staffLists = [
  {
    name: "Ashley Palma",
    role: "Senior Developer",
    country: "Philippines",
    flag: "🇵🇭",
    status: "offline",
    lastSeen: "1 hour ago",
  },
  {
    name: "Saccharine Elupre",
    role: "Marketing Manager",
    country: "India",
    flag: "🇮🇳",
    status: "offline",
    lastSeen: "2 hours ago",
  },
  {
    name: "Emily Rodriguez",
    role: "Frontend Developer",
    country: "Colombia",
    flag: "🇨🇴",
    status: "away",
    lastSeen: "2 mins ago",
  },
  {
    name: "James Wilson",
    role: "HR Specialist",
    country: "Philippines",
    flag: "🇵🇭",
    status: "offline",
    lastSeen: "1 hour ago",
  },
  {
    name: "Lisa Anderson",
    role: "Financial Analyst",
    country: "Sri Lanka",
    flag: "🇱🇰",
    status: "away",
    lastSeen: "7 mins ago",
  },
  {
    name: "David Martinez",
    role: "DevOps Engineer",
    country: "Colombia",
    flag: "🇨🇴",
    status: "away",
    lastSeen: "10 mins ago",
  },
  {
    name: "Jennifer Lee",
    role: "UX Designer",
    country: "Philippines",
    flag: "🇵🇭",
    status: "online",
    lastSeen: "Active now",
  },
  {
    name: "Robert Taylor",
    role: "Sales Director",
    country: "India",
    flag: "🇮🇳",
    status: "offline",
    lastSeen: "1 hour ago",
  },
  {
    name: "Acee Cayanan",
    role: "Creative Director",
    country: "Australia",
    flag: "🇦🇺",
    status: "away",
    lastSeen: "9 mins ago",
  },
  {
    name: "Chris Brown",
    role: "Backend Developer",
    country: "India",
    flag: "🇮🇳",
    status: "away",
    lastSeen: "12 mins ago",
  },
  {
    name: "Patricia Garcia",
    role: "Data Analyst",
    country: "Philippines",
    flag: "🇵🇭",
    status: "away",
    lastSeen: "19 mins ago",
  },
  {
    name: "Daniel Moore",
    role: "Support Specialist",
    country: "Colombia",
    flag: "🇨🇴",
    status: "online",
    lastSeen: "Active now",
  },
];
